import React from 'react';
import { Link } from 'react-router-dom';

const DoctoralPrograms = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <h2 className="text-3xl font-bold mb-4">Doctoral Programs</h2>
        <p className="mb-4">
          Hamilton College of the Bahamas offers a variety of doctoral programs designed to prepare students for advanced careers in their chosen fields. Our programs are rigorous and designed to provide students with the knowledge and skills necessary to succeed in their careers.
        </p>
        <h3 className="text-2xl font-bold mb-4">Doctor of Ministry (D.Min)</h3>
        <p className="mb-4">
          The <Link to="/academics/dr_ministry" className="text-blue-500 underline">Doctor of Ministry</Link> program is designed for those who are currently engaged in ministry and wish to enhance their skills and knowledge. The program focuses on practical ministry skills and includes courses in leadership, counseling, and theology.
        </p>
        <h3 className="text-2xl font-bold mb-4">Doctor of Business Administration (DBA)</h3>
        <p className="mb-4">
          The <Link to="/academics/dr_business_admin" className="text-blue-500 underline">Doctor of Business Administration</Link> program is designed for those who wish to pursue advanced careers in business. The program includes courses in management, finance, and marketing, and is designed to provide students with the skills necessary to succeed in the business world.
        </p>
        <h3 className="text-2xl font-bold mb-4">Doctor of Philosophy (Ph.D)</h3>
        <p className="mb-4">
          The <Link to="/academics/dr_philosophy" className="text-blue-500 underline">Doctor of Philosophy</Link> program is designed for those who wish to pursue advanced academic careers. The program includes courses in research methods, statistics, and advanced topics in the student's chosen field of study.
        </p>
      </div>
    </div>
  );
};

export default DoctoralPrograms;